import * as React from 'react';

// Utils
import { t } from '@toolkit/util/i18n';
import { head, isNil } from '@src/shared/src/util/general';
import { getProduct, getOperator } from '@src/shared/src/util/trips';
import { getVehicleIcon } from '@toolkit/util/app';
import { formatDate } from '@src/shared/src/util/date';
// Constants
import { ENVIRONMENT, DATE_FORMAT_TYPES, VEHICLE_TYPES } from '@src/shared/src/const/app';
// Actions
// Models
import { TransportSegmentModel } from '@src/shared/src/models';
// Interfaces
// Components
// Styles
import '../styles/TransportSegment.scss';

type Props = {
  env: ENVIRONMENT;
  transportSegment: TransportSegmentModel;
};

export default class TransportSegment extends React.PureComponent<Props> {
  private getPlatformMarkup = (
    env: ENVIRONMENT,
    isDep: boolean,
    transportSegment: TransportSegmentModel,
  ) => {
    const showPlatform = isDep
      ? !isNil(transportSegment.depPlatform)
      : !isNil(transportSegment.arrPlatform);

    if (env !== ENVIRONMENT.SEARCH && showPlatform) {
      return (
        <div>
          {`${
            isDep
              ? t('transportSegment.label.platform.dep')
              : t('transportSegment.label.platform.arr')
          }
              ${isDep ? transportSegment.depPlatform : transportSegment.arrPlatform}`}
        </div>
      );
    }
  };

  private getProductName = (transportSegment: TransportSegmentModel) => {
    switch (head(transportSegment.vehicles)) {
      case VEHICLE_TYPES.WALKING:
        return t('transportSegment.label.walking');
      case VEHICLE_TYPES.PLANE:
        return `${getOperator(transportSegment.operators)} ${getProduct(
          transportSegment.products,
        )}`;
      default:
        return getProduct(transportSegment.products);
    }
  };

  private getProductMarkup = (transportSegment: TransportSegmentModel) => {
    // In case of flights we need to display the operator code as well

    const productIcon = transportSegment.iconURL ? (
      <img className="product-icon" src={transportSegment.iconURL} />
    ) : (
      <i className={getVehicleIcon(head(transportSegment.vehicles))} />
    );
    return (
      <>
        {productIcon}
        <span>{this.getProductName(transportSegment)}</span>
      </>
    );
  };

  private getProductTravelClass = (transportSegment: TransportSegmentModel) => {
    return (
      <>
        {transportSegment.travelClass && (
          <>
            <i className="material-symbols ml-2">flight_class</i>
            <span>{transportSegment.fareName}</span>
          </>
        )}
      </>
    );
  };

  private getTechnicalStops = (transportSegment: TransportSegmentModel) => {
    return (
      <>
        {transportSegment.technicalStops &&
          transportSegment.technicalStops.map((stop, i) =>
            <span className="tcp-label-button-no-hover mt-2" key={`technical-stop-${i}`}>
              <i className="material-symbols">airline_stops</i>{t('technicalStop.label', {location: stop.location, duration:stop.duration})}
            </span>
          )
        }
      </>
    );
  };

  public render() {
    const { env, transportSegment } = this.props;
    return (
      <div className="tcp-transport-segment">
        <div className="tcp-transport-segment-time">
          <span>{formatDate(transportSegment.depAt, DATE_FORMAT_TYPES.LONG_TIME)}</span>
          <span>{formatDate(transportSegment.arrAt, DATE_FORMAT_TYPES.LONG_TIME)}</span>
        </div>
        <div className="tcp-transport-segment-connect" />
        <div className="tcp-transport-segment-inner">
          <div className="tcp-transport-segment-item">
            <span className="tcp-transport-segment-location">{transportSegment.depName}</span>
            <span className="tcp-transport-segment-direction">
              {this.getPlatformMarkup(env, true, transportSegment)}{' '}
              {this.getProductMarkup(transportSegment)}
              {this.getProductTravelClass(transportSegment)}
            </span>
            {this.getTechnicalStops(transportSegment)}
          </div>

          <div className="tcp-transport-segment-item">
            <span className="tcp-transport-segment-direction">
              {this.getPlatformMarkup(env, false, transportSegment)}
            </span>
            <span className="tcp-transport-segment-location">{transportSegment.arrName}</span>
          </div>
        </div>
      </div>
    );
  }
}
